import appLocaleData from 'react-intl/locale-data/id';
import enMessages from '../locales/id_ID';

const IdLang = {
    messages: {
        ...enMessages
    },
    locale: 'id-ID',
    data: appLocaleData
};
export default IdLang;